import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import config from 'config';
import {
    fetchCompanyRequested,
    fetchMembersRequested,
    removeMembersRequested,
    updateMemberRequested,
} from 'services/company/action';

import Employees from './Employees';


class Index extends React.Component {

    componentDidMount() {
        const {fetchCompany} = this.props;
        fetchCompany();
        const {user} = this.props;
        this.setState({...user});
    }

    render() {
        const {
            user, company, addNotification,
            company: {members},
            updateMember, removeMembers,
        } = this.props;
        const {roles, statuses, statusMap} = config;

        const membersToShow = members.filter(member => member.status !== statusMap.deleted);

        return (
            <Employees
                members={membersToShow}
                roles={roles}
                statuses={statuses}
                updateMember={updateMember}
                removeMembers={removeMembers}
                addNotification={addNotification}
                user={user}
                company={company}
                fetchCompany={this.props.fetchCompany}
            />
        );
    }
}

Index.propTypes = {
    user: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    addNotification: PropTypes.func.isRequired,
    fetchMembers: PropTypes.func.isRequired,
    updateMember: PropTypes.func.isRequired,
    removeMembers: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
    fetchMembers: () => {
        dispatch(fetchMembersRequested());
    },
    updateMember: (memberInfo) => {
        dispatch(updateMemberRequested(memberInfo));
    },
    removeMembers: (membersList) => {
        dispatch(removeMembersRequested(membersList));
    },
    fetchCompany: () => {
        dispatch(fetchCompanyRequested());
    },
});

export default connect(null, mapDispatchToProps)(Index);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/index.jsx